/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type FormSubmitEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const formSubmitEntrypoint: EntryPoint<FormSubmitEntrypointComponent, {}> = createEntryPoint(
	{
		root: JSResourceForUserVisible<FormSubmitEntrypointComponent>(
			/* webpackChunkName: "async-software-form-submit-entrypoint" */ './index.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	},
);
